import Point from '@arcgis/core/geometry/Point';
import Query from '@arcgis/core/rest/support/Query';
import QueryTask from '@arcgis/core/tasks/QueryTask';
import { appConfig } from 'cd-eft/config/AppConfig';

export async function getRainfallCellID(point: Point): Promise<number> {
  const queryUrl = appConfig.hydrologyGisLayers.rainfallFeatureLayer;
  const geometry = point;
  //const outSpatialReference = params.outSpatialReference;

  const queryTask = new QueryTask({
    url: queryUrl,
  });

  const query = new Query({
    outFields: ['*'],
    returnGeometry: false,
    //outSpatialReference: outSpatialReference,
    where: '1=1',
    geometry: geometry,
    spatialRelationship: 'intersects',
  });

  const featureSet = await queryTask.execute(query);
  const idSet = featureSet.features.map(function (graphic: any) {
    return (graphic.attributes['ID'] ?? graphic.attributes['id']) as number;
  });

  return idSet[0];

}